import { AfterViewInit, Component, Inject } from '@angular/core';
import { SidebarService } from '@layout/core/services';
import { CommonModule, DOCUMENT } from '@angular/common';
import { environment } from '@environments/environment';
import { SidebarModule } from 'primeng/sidebar';
import { AppNavigationComponent } from '@layout/components/app-navigation/app-navigation.component';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
    host: {
        '(window:resize)': 'onScreenResize()',
    },
    standalone: true,
    imports: [CommonModule, SidebarModule, AppNavigationComponent, ButtonModule],
})
export class SidebarComponent implements AfterViewInit {
    isVisible = true;
    isCollapsed = true;
    hasScrollbar = false;

    readonly quickorderDashboardUrl = environment.quickorderDashboardUrl;

    constructor(
        private sidebarService: SidebarService,
        @Inject(DOCUMENT) private document: Document
    ) {
        this.onScreenResize();
        sidebarService.isCollapsed$.subscribe((isCollapsed: boolean) => {
            this.isCollapsed = isCollapsed;
        });
    }

    ngAfterViewInit(): void {
        this.onScreenResize();
    }

    toggleIsCollapsed(): void {
        this.sidebarService.toggleIsCollapsed();
    }

    onScreenResize() {
        const scrollHeight = this.document.getElementsByClassName('p-sidebar-content')[0]?.scrollHeight || 0;
        const clientHeight = this.document.getElementsByClassName('app-sidebar')[0]?.clientHeight || 0;
        this.hasScrollbar = scrollHeight + 70 > clientHeight;
    }
}
